import React, { useRef } from "react";
import { CircularProgress, Typography } from "@mui/material";
import AgentAvatar from "../AgentAvatar";
import "./AgentAvatarField.css";

export default function AgentAvatarField({
  agentId,
  name,
  displayAvatarUrl,
  canEditAvatar,
  uploadingAvatar,
  avatarError,
  onSelectFile,
  onRemove,
  avatarAccept,
}) {
  const inputRef = useRef(null);

  const handleInputChange = (event) => {
    const file = event.target.files?.[0];
    event.target.value = "";
    if (file) {
      onSelectFile(file);
    }
  };

  const handleAvatarClick = () => {
    if (!canEditAvatar || uploadingAvatar) return;
    if (displayAvatarUrl) {
      onRemove();
      return;
    }
    inputRef.current?.click();
  };

  return (
    <div className="agent-avatar-field">
      <div className="agent-avatar-field__preview-wrap">
        <AgentAvatar
          agentId={agentId}
          name={name}
          src={displayAvatarUrl}
          size={64}
          borderRadius="14px"
          onClick={canEditAvatar ? handleAvatarClick : undefined}
        />
        {uploadingAvatar && (
          <CircularProgress
            size={22}
            sx={{
              position: "absolute",
              inset: 0,
              m: "auto",
            }}
          />
        )}
      </div>

      {canEditAvatar && (
        <input
          ref={inputRef}
          className="agent-avatar-field__input"
          type="file"
          accept={Object.keys(avatarAccept).join(",")}
          onChange={handleInputChange}
          disabled={uploadingAvatar}
        />
      )}

      {avatarError && (
        <Typography sx={{ fontSize: 12, color: "error.main" }}>
          {avatarError}
        </Typography>
      )}
    </div>
  );
}
